import { render, staticRenderFns } from "./SortOrderTable.vue?vue&type=template&id=95861972&"
import script from "./SortOrderTable.vue?vue&type=script&lang=js&"
export * from "./SortOrderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports